import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PromotionLayer from "../../components/Promotion/PromotionLayer";


const PromiotionList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Promotion" />

        {/* UsersListLayer */}
        <PromotionLayer />

      </MasterLayout>

    </>
  );
};

export default PromiotionList; 
